export const ErrorMessageWidget = ({message}) => {
    return (
        <span className={`text-xs text-red-500`}>
            {message}
        </span>
    )
}
